export class PriLogEntity{
    id:number;
    labelId:number;
    serial:string;
    printDate:string;
    personId:number;

    constructor(){}
}